export function tlLogDebugString(logValue: string, logName: string | null = null): void {
	if (process.env.NODE_ENV === "development") {
		if (logName) {
			console.log('Debug - ' + logName + ': ' + logValue);
		}
		else {
			console.log('Debug - ' + logValue);
		}
	}
}

export function tlLogDebug(logName: string, logValue: any): void {
	if (process.env.NODE_ENV === "development") {
		console.log('Debug - ' + logName + ':');
		console.log(logValue);
	}
}

export function tlLogError(logName: string, logValue: string): void {
	console.log('Error - ' + logName + ': ' + logValue);
}




